<!--
  @description 网上事故录入
  @author xiehan
  @date 2018/12/11
-->
<template>
  <div class="accidentEntry__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('common.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item :label="$t('accidentEntry.effectLevel')" input-width="auto">
        <g-select v-model="searchForm.effectLevel" :list="select_level" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('accidentEntry.group')" input-width="auto">
        <g-select v-model="searchForm.group" :list="select_group" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('accidentEntry.reason')" input-width="auto">
        <g-select v-model="searchForm.reason" :list="select_reason" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('accidentEntry.status')" input-width="auto">
        <g-select v-model="searchForm.status" :list="select_status" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item input-width="auto">
        <el-button type="primary" 
          v-g-rac="gRac('accidentEntry_search')"
          @click="search"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary" 
          v-g-rac="gRac('accidentEntry_add')"
          @click="addAccident"
          v-text="$t('common.add')"></el-button>
        <el-button type="primary" 
          v-g-rac="gRac('accidentEntry_export')"
          @click="e_export"
          v-text="$t('accidentEntry.export')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="accidentDiaTitle"
      :visible.sync="accidentDiaVis"
      width="400px">
      <el-form ref="handleForm" :model="handleForm" input-width="180px" label-width="80px" :rules="rules">
        <el-form-item :label="$t('accidentEntry.title')" prop="title">
          <el-input v-model="handleForm.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.startTime')" prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="handleForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.findTime')" prop="findTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="handleForm.findTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.endTime')" prop="endTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="handleForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.effect')" prop="effect">
          <el-input v-model="handleForm.effect"></el-input>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.status')" prop="status">
          <g-select v-model="handleForm.status" :list="select_status"></g-select>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.group')" prop="group">
          <g-select v-model="handleForm.group" :list="select_group"></g-select>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.effectLevel')" prop="effectLevel">
          <g-select v-model="handleForm.effectLevel" :list="select_level"></g-select>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.reason')" prop="reason">
          <g-select v-model="handleForm.reason" :list="select_reason"></g-select>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.problemSource')" prop="problemSource">
          <g-select v-model="handleForm.problemSource" :list="select_source"></g-select>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.detail')" prop="detail" input-width="auto">
          <el-input v-model="handleForm.detail" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.reasonAnalysis')" prop="reasonAnalysis" input-width="auto">
          <el-input v-model="handleForm.reasonAnalysis" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.solution')" prop="solution" input-width="auto">
          <el-input v-model="handleForm.solution" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item :label="$t('accidentEntry.correctAction')" prop="correctAction" input-width="auto">
          <el-input v-model="handleForm.correctAction" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accidentDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="primary" @click="accidentDiaConfirm" v-text="$t('common.confirm')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import systemSettingBiz from '@/logic/systemSetting/systemSettingBiz'
  import exportTips from '@/components/mixins/exportTips'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  const DIC_MAP = {
    status: 'accidentStatus',
    group: 'groupType',
    reason: 'accidentType',
    effectLevel: 'effectLevel',
    problemSource: 'problemSource'
  }
  export default {
    mixins: [rac, dic, table, exportTips],
    data () {
      return {
        searchForm: {
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: '',
          effectLevel: '',
          group: '',
          reason: '',
          status: ''
        },
        select_group: {},
        select_reason: {},
        select_status: {},
        select_level: {},
        select_source: {},
        accidentDiaTitle: this.$t('common.add'),
        accidentDiaVis: false,
        handleForm: {
          title: '',
          startTime: '',
          findTime: '',
          endTime: '',
          effect: '',
          status: '',
          group: '',
          effectLevel: '',
          reason: '',
          problemSource: '',
          detail: '',
          reasonAnalysis: '',
          solution: '',
          correctAction: ''
        },
        isEdit: false,
        rules: {},
        tableControl: [
          {
            label: this.$t('common.check'),
            callback: (row, index, data) => {
              this.$router.push({ name: 'accidentDetail', query: { id: row.id } })
            },
            rac: () => this.gRac('accidentEntry_check')
          }, {
            label: this.$t('common.edit'),
            callback: (row, index, data) => {
              this.accidentDiaVis = true
              this.accidentDiaTitle = this.$t('common.edit')
              this.selectId = row.id
              for (let i in this.handleForm) {
                this.handleForm[i] = row[i]
              }
              this.handleForm.startTime = TimeFormat.formatTimeTolong(this.handleForm.startTime)
              this.handleForm.status = Object.keys(this.select_status)
                .filter(item => this.select_status[item] === this.handleForm.status)[0]
              this.handleForm.effectLevel = Object.keys(this.select_level)
                .filter(item => this.select_level[item] === this.handleForm.effectLevel)[0]
              this.handleForm.reason = Object.keys(this.select_reason)
                .filter(item => this.select_reason[item] === this.handleForm.reason)[0]
              this.handleForm.group = Object.keys(this.select_group)
                .filter(item => this.select_group[item] === this.handleForm.group)[0]
            },
            rac: () => this.gRac('accidentEntry_amend')
          }, {
            label: this.$t('common.delete'),
            callback: (row, index, data) => {
              this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
              }).then(() => {
                systemSettingBiz.deleteAccident({ id: row.id }).then(() => {
                  this.successMessage()
                  this.searchTable()
                })
              }).catch(() => {})
            },
            rac: () => this.gRac('accidentEntry_delete')
          }
        ],
        selectId: '',
        doExport: null
      }
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetDictionaryByCode('groupType'),
          this.dGetDictionaryByCode('accidentType'),
          this.dGetDictionaryByCode('accidentStatus'),
          this.dGetDictionaryByCode('effectLevel'),
          this.dGetDictionaryByCode('problemSource')
        ])
        this.select_group = { ...this.dDictionary.groupType }
        this.select_reason = { ...this.dDictionary.accidentType }
        this.select_status = { ...this.dDictionary.accidentStatus }
        this.select_level = { ...this.dDictionary.effectLevel }
        this.select_source = { ...this.dDictionary.problemSource }
        this.handleForm.group = Object.keys(this.select_group)[0]
        this.handleForm.reason = Object.keys(this.select_reason)[0]
        this.handleForm.status = Object.keys(this.select_status)[0]
        this.handleForm.effectLevel = Object.keys(this.select_level)[0]
        this.handleForm.problemSource = Object.keys(this.select_source)[0]
        this.initTable()
        this.setRules()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'accidentEntry.table',
          head: ['title', 'status', 'effectLevel', 'detail', 'startTime', 'duration', 'effect', 'reason', 'group'],
          requestFun: this.searchTable,
          headOpt: {
            status: {
              formatter: 'Dictionary',
              formatterDic: this.select_status
            },
            group: {
              formatter: 'Dictionary',
              formatterDic: this.select_group
            },
            reason: {
              formatter: 'Dictionary',
              formatterDic: this.select_reason
            },
            effectLevel: {
              formatter: 'Dictionary',
              formatterDic: this.select_level
            }
          }
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        if (!reqData.endTime) reqData.endTime = new Date().getTime()
        systemSettingBiz.getAccident(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.startTime = TimeFormat.getFormatTime(item.startTime)
              item.duration = TimeFormat.getAutoFormatTime(item.duration)
            })
          }
          this.tData = data
        })
      },
      addAccident () {
        this.accidentDiaVis = true
        this.accidentDiaTitle = this.$t('common.add')
        this.isEdit = false
        for (let i in this.handleForm) {
          this.handleForm[i] = ''
        }
        this.$nextTick(() => {
          this.$refs['handleForm'].clearValidate()
        })
      },
      e_export () {
        const search = extend({}, this.searchForm)
        if (!this.doExport) this.doExport = this.exportTable()
        this.doExport(search)
      },
      exportTable () {
        const that = this
        const list = Object.assign({}, that.$t('accidentEntry.table'))
        list.problemSource = that.$t('accidentEntry.problemSource')
        list.reasonAnalysis = that.$t('accidentEntry.reasonAnalysis')
        list.solution = that.$t('accidentEntry.solution')
        list.correctAction = that.$t('accidentEntry.correctAction')
        const dictionary = []
        for (const key in DIC_MAP) {
          dictionary.push({
            relate: key,
            type: that.dDictionary[DIC_MAP[key]]
          })
        }
        return function (search) {
          that.exRenderBefore()
          systemSettingBiz.exportAccident(
            list,
            search,
            ['startTime'],
            ['duration'],
            dictionary,
            that.exRenderTips,
            that.exRenderFail
          )
        }
      },
      setRules () {
        for (let i in this.handleForm) {
          this.rules[i] = [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('accidentEntry.' + i)}` }
          ]
        }
      },
      accidentDiaConfirm () {
        this.$refs['handleForm'].validate((valid) => {
          if (valid) {
            let eventName = this.accidentDiaTitle === this.$t('common.edit')
              ? 'changeAccident' : 'addAccident'
            let saveObj = extend(true, {}, this.handleForm)
            if (this.accidentDiaTitle === this.$t('common.edit')) saveObj.id = this.selectId
            systemSettingBiz[eventName](saveObj).then(data => {
              this.accidentDiaVis = false
              this.successMessage()
              this.searchTable()
            })
          } else {
            return false
          }
        })
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      }
    },
    watch: {
      isEdit (val) {
        this.accidentDiaTitle = val ? this.$t('common.edit') : this.$t('common.add')
      }
    },
    mounted () {
      this.preInitTable()
      this.searchTable()
    }
  }
</script>

<style scoped>

</style>